<div class="centered">

<mat-card class="details" >
        <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
          <tr>
              <div class="maher" (click)="myApp.showCharts()"></div>

            <td style="width: 70%">
              <div class="smallerFont" style="font-size: 15px; padding-top: 10px">
                The SID key is your API username which will be generated once upon subscribing.<br>
                The Authorization Token key is your password which you can re-generate at any time, if needed.<br>
                The SID and token keys must be passed in the API header call to Maher Terminals.<br>
              </div>
              <div style="padding-top: 20px">
                <mat-form-field appearance="outline" style="width: 98%">
                  <mat-label style="font-size: 18px; color: #E61E00">Username</mat-label>
                  <input [(ngModel)]="myUser.username"  matInput readonly/>
                </mat-form-field>
              </div>
              <div style="padding-top: 2px">
                <mat-form-field appearance="outline" style="width: 98%">
                  <mat-label style="font-size: 18px; color: #E61E00">API SID</mat-label>
                  <input [(ngModel)]="apiSid"  matInput readonly/>
                </mat-form-field>
              </div>
              <div style="padding-top: 2px">
                <mat-form-field appearance="outline" style="width: 98%">
                  <mat-label style="font-size: 18px; color: #E61E00">API Authorization Token</mat-label>
                  <input [(ngModel)]="apiToken"  matInput readonly/>
                </mat-form-field>
              </div>
            </td>
            <td style="width: 30%; padding-bottom: 50px">
              <button mat-raised-button  class="blueButton" (click)="generateKeys()"> Generate Key(s)</button>
            </td>
          </tr>
        </table>
</mat-card>
</div>

